/**
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { ClientConstants } from './../client.constants';
import { ContentModel } from './../models/content-model';
import axios from 'axios';
export default class ContentService {
    public static async getContent(): Promise<ContentModel> {
        const config = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        };
        try {
            const content = await axios.get(ClientConstants.CONTENT_URL, config);
            return content.data;
        } catch (error) {
            throw new Error(ClientConstants.CONTENT_SERVICE_REQUEST_ERROR + '\n' + error);
        }
    }
}
